var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:`icon icon--${_vm.id}`},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',{attrs:{"xlink:href":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }